import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Button } from 'primeng/button';
import { Textarea } from 'primeng/textarea';
import { OffboardingService } from '../../services/offboarding.service';
import { PublicQuestionnaire, QuestionnaireAnswer } from '../../models/offboarding.model';

@Component({
  selector: 'app-exit-questionnaire',
  standalone: true,
  imports: [CommonModule, FormsModule, Button, Textarea],
  templateUrl: './exit-questionnaire.component.html',
  styleUrl: './exit-questionnaire.component.scss'
})
export class ExitQuestionnaireComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private route = inject(ActivatedRoute);
  private offboardingService = inject(OffboardingService);

  token = '';
  questionnaire: PublicQuestionnaire | null = null;
  loading = true;
  notFound = false;
  saving = false;
  submitted = false;

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token') ?? '';
    if (!this.token) {
      this.loading = false;
      this.notFound = true;
      return;
    }

    this.offboardingService.getPublicQuestionnaire(this.token)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.questionnaire = data;
          this.submitted = data.isCompleted;
          this.loading = false;
        },
        error: () => {
          this.notFound = true;
          this.loading = false;
        }
      });
  }

  save(): void {
    if (!this.questionnaire || this.saving) return;
    this.saving = true;

    this.offboardingService.submitPublicQuestionnaire(this.token, this.questionnaire.answers)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (result) => {
          this.questionnaire = result;
          this.submitted = true;
          this.saving = false;
        },
        error: () => {
          this.saving = false;
        }
      });
  }

  get hasAnswers(): boolean {
    return this.questionnaire?.answers?.some(a => a.answer?.trim()) ?? false;
  }
}
